module.exports = __webpack_public_path__ + "media/images/Anthony-B-33f48777307da3067d5a15069a0c4209.png";